module.exports = __webpack_public_path__ + "static/media/map_marker.d02f6594.png";